var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.01,
    height: 15,
    viewBox: "0 0 15.01 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13033",
    "data-name": "Group 13033",
    transform: "translate(-4514.495 -1574.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M1108.172,378.1q0-3.09,0-6.181a1.284,1.284,0,0,1,1.059-1.3,1.3,1.3,0,0,1,.257-.019q3.6,0,7.2,0a1.282,1.282,0,0,1,1.32,1.311c0,.339,0,.678,0,1.017a.786.786,0,1,1-1.571-.005c0-.194-.008-.388,0-.581.007-.137-.046-.173-.177-.173-1.14,0-2.28,0-3.421,0-.963,0-1.925,0-2.888,0-.161,0-.211.039-.211.206q.008,5.729,0,11.457c0,.157.047.2.2.2q3.147-.008,6.293,0c.151,0,.213-.035.2-.2-.013-.2-.005-.4,0-.6a.785.785,0,0,1,1.569-.009c.006.382.007.764,0,1.146a1.278,1.278,0,0,1-1.227,1.222q-3.687.009-7.375,0a1.272,1.272,0,0,1-1.228-1.27Q1108.17,381.215,1108.172,378.1Z",
    transform: "translate(3406.323 1203.897)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M1120.446,378.913a.353.353,0,0,0-.2-.023H1112.1a.786.786,0,1,1-.013-1.571q4.076,0,8.15,0h.2c-.012-.076-.067-.106-.1-.145-.471-.473-.945-.942-1.414-1.417a.757.757,0,0,1-.207-.814.769.769,0,0,1,.643-.543.739.739,0,0,1,.664.22q1.47,1.462,2.932,2.933a.774.774,0,0,1,0,1.106q-1.455,1.468-2.922,2.922a.791.791,0,1,1-1.1-1.131c.464-.471.935-.936,1.4-1.4C1120.364,379,1120.4,378.96,1120.446,378.913Z",
    transform: "translate(3406.323 1203.897)",
    fill: "#74613c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a7e3af0eee30835da052b84ff8a23199.svg";
export { ForwardRef as ReactComponent };